import { render, staticRenderFns } from "./NewRequestForm.vue?vue&type=template&id=39aff851&scoped=true"
import script from "./NewRequestForm.vue?vue&type=script&lang=js"
export * from "./NewRequestForm.vue?vue&type=script&lang=js"
import style0 from "./NewRequestForm.vue?vue&type=style&index=0&id=39aff851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aff851",
  null
  
)

export default component.exports